import { createContext, useEffect, useReducer } from "react";
import Cookie from "universal-cookie";

export const AuthContext = createContext();

export const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return { user: action.payload };
    case "LOGOUT":
      return { user: null };
    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const cookie = new Cookie(null, { path: "/" });

  const [state, dispatch] = useReducer(authReducer, {
    user: null,
  });

  useEffect(() => {
    const token = cookie.get("token");
    const username = cookie.get("username");
    const userId = cookie.get("userId");
    const isAdmin = cookie.get("isAdmin");
    const fullName = cookie.get("fullName");
    const isModerator = cookie.get("isModerator");

    if (token) {
      dispatch({
        type: "LOGIN",
        payload: { username, token, userId, isAdmin, isModerator, fullName },
      });
    } else {
      dispatch({ type: "LOGOUT", payload: null });
    }
  }, []);

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
